<button
  class="ui-checkbox-row"
  role="checkbox"
  type="button"
  [class.ui-checkbox-row-checked]="checked()"
  [disabled]="disabled()"
  [attr.aria-label]="accessibleLabel()"
  [attr.aria-checked]="checked() ? 'true' : 'false'"
  (click)="handleToggle($event)"
>
  <span class="ui-checkbox-row-box" aria-hidden="true">
    @if (checked()) {
      <span class="ui-checkbox-row-check">ok</span>
    }
  </span>
  <span class="ui-checkbox-row-copy">
    <span class="ui-checkbox-row-title">{{ title() }}</span>
    @if (hasDescription()) {
      <span class="ui-checkbox-row-description">{{ description() }}</span>
    }
  </span>
</button>
